<nz-form-item>
	<nz-form-label [nzSpan]="18" nzFor="workflow">Workflow</nz-form-label>
	<nz-form-control [nzSpan]="6">
		<nz-select [(ngModel)]="workflow" id="workflow">
			<ng-container *ngFor="let item of workflows">
				<nz-option [nzValue]="item" [nzLabel]="item.label"></nz-option>
			</ng-container>
		</nz-select>
	</nz-form-control>
</nz-form-item>

<nz-table #resultsTable nzBordered [nzData]="_data??[]" [nzBordered]="true" [nzSize]="'middle'" [nzLoading]="loading" [nzPageSize]="10" [nzFrontPagination]="true" class="mt-4">
	<thead>
		<tr>
			<th>Full Name</th>
			<th>ID Number</th>
			<th><span class="float-end">Create {{ticketMode}}</span></th>
		</tr>
	</thead>
	<tbody>
		<ng-container *ngFor="let member of resultsTable.data">
			<tr>
				<td [(nzExpand)]="member.expanded">{{ member.payload.name }} {{ member.payload.surname}}</td>
				<td>{{ member.payload.idNumber }}</td>
				<td>
					<button nz-button nzType="primary" nzSize="small" *ngIf="!canCreateMemberTicket(member)" disabled class="float-end">Create {{workflow?.label??ticketMode}}</button>
					<button nz-button nzType="primary" nzSize="small" *ngIf="canCreateMemberTicket(member)" (click)="startTicketForMember(member)" class="float-end">Create {{workflow?.label??ticketMode}}</button>
				</td>
			</tr>
			<tr *ngIf="member.dependents.length > 0 || member.memberships.length > 0" [nzExpand]="member.expanded">
				<div class="ms-5">
					<ng-container *ngTemplateOutlet="membershipTableTemplate"></ng-container>
					<ng-container *ngTemplateOutlet="dependantTableTemplate"></ng-container>
				</div>
				<ng-template #membershipTableTemplate>
					<nz-table #membershipTable nzSize="small" [nzData]="member.memberships" [nzFrontPagination]="false">
						<thead>
							<tr>
								<th>Membership No.</th>
								<th>Category</th>
								<th
									[nzChecked]="member.checked"
									[nzIndeterminate]="member.indeterminate"
									(nzCheckedChange)="onAllChecked(member, $event)">
									Select All
								</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let item of membershipTable.data">
								<tr>
									<td>{{item.payload.membershipNumber}}</td>
									<td>{{item.payload.category}}</td>
									<td
										[nzChecked]="member.setOfCheckedId.has(item.payload.id)"
										(nzCheckedChange)="onItemChecked(member, item, $event)">
									</td>
								</tr>
							</ng-container>
						</tbody>
					</nz-table>
				</ng-template>
				<ng-template #dependantTableTemplate>
					<nz-table nzSize="small" [nzData]="member.dependents" [nzFrontPagination]="false">
						<thead>
							<tr>
								<th>Dependent No.</th>
								<th>Full Name</th>
								<th>ID Number</th>
								<th>Relationship</th>
								<th><span class="float-end">Create {{ticketMode}}</span></th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let item of member.dependents">
								<tr>
									<td>{{item.dependantNumber}}</td>
									<td>{{item.name}} {{item.surname}}</td>
									<td>{{item.idNumber}}</td>
									<td>{{item.relationship}}</td>
									<td>
										<button nz-button nzType="primary" nzSize="small" *ngIf="!canCreateDependantTicket(member)" disabled class="float-end">Create {{workflow?.label??ticketMode}}</button>
										<button nz-button nzType="primary" nzSize="small" *ngIf="canCreateDependantTicket(member)" (click)="startTicketForDependant(item)" class="float-end">Create {{workflow?.label??ticketMode}}</button>
									</td>
								</tr>
							</ng-container>
						</tbody>
					</nz-table>
				</ng-template>
			</tr>
		</ng-container>
	</tbody>
</nz-table>
